/**
 * Variant Picker Label Sync
 * ----------------------------------------------------------------------------
 * Keeps the "selected value" label shown next to each option legend (e.g.
 * "Colour: C10 - RED") in sync with the currently chosen swatch / variant image.
 *
 * Why this exists
 * ----------------------------------------------------------------------------
 * Normally the theme's native VariantPicker re-renders this label on the server
 * when the variant changes. On this wholesale / "Become a stockist" storefront
 * the product <form> is not rendered for guests, so the native picker throws and
 * never re-renders. This script updates the label directly from the selected
 * radio instead, so it works with or without the form.
 *
 * Markup contract (rendered by snippets/variant-picker.liquid + option-value.liquid)
 * ----------------------------------------------------------------------------
 * - Label:  <span data-selected-value data-option-position="N" data-form-id="F">
 * - Radio:  <input data-option-position="N" data-option-text="Value" form="F">
 */

(function () {
  function syncLabelFrom(input) {
    if (!input || typeof input.matches !== "function") return;
    if (!input.matches("input[data-option-position]") || !input.checked) return;

    const position = input.getAttribute("data-option-position");
    const text = input.dataset.optionText;
    if (!position || text == null) return;

    const formId = input.getAttribute("form");
    let selector = `[data-selected-value][data-option-position="${position}"]`;
    if (formId) selector += `[data-form-id="${formId}"]`;

    document.querySelectorAll(selector).forEach((span) => {
      span.textContent = text;
    });
  }

  // Dropdown selector: mirror the chosen option into the closed dropdown button.
  function syncDropdownFrom(input) {
    if (!input || typeof input.matches !== "function" || !input.checked) return;
    const popover = input.closest("x-popover");
    const option = input.closest(".popover__value-option");
    if (!popover || !popover.id || !option) return;

    const valueEl = option.querySelector(":scope > span");
    const target = document.getElementById(`${popover.id}-selected-value`);
    if (valueEl && target) target.textContent = valueEl.textContent.trim();
  }

  // Dropdown stock labels (Preorder / In Stock / "Only N left") are rendered for the
  // variant selected at page load, so they go stale when another option (e.g. colour)
  // is chosen. Re-fetch the picker for the new combination and swap the value lists.
  let refreshToken = 0;

  function selectedText(picker, position) {
    const input = picker.querySelector(`input[data-option-position="${position}"]:checked`);
    if (!input) return null;
    if (input.dataset.optionText != null) return input.dataset.optionText;
    const label = input.closest(".popover__value-option");
    const span = label && label.querySelector(":scope > span");
    return span ? span.textContent.trim() : null;
  }

  async function refreshDropdownLabels(input) {
    const picker = input && input.closest && input.closest("variant-picker");
    if (!picker || !picker.querySelector("x-popover .popover__value-list")) return;

    const dataEl = picker.querySelector("script[data-variant-availability]");
    if (!dataEl) return;

    let variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const count = variants.length ? variants[0].options.length : 0;
    const wanted = [];
    for (let i = 1; i <= count; i += 1) {
      const text = selectedText(picker, i);
      if (text == null) return;
      wanted.push(text);
    }

    const match = variants.find((v) => v.options.every((o, i) => o === wanted[i]));
    if (!match) return;

    const token = ++refreshToken;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", match.id);
    url.searchParams.set("section_id", picker.getAttribute("section-id"));

    try {
      const response = await fetch(url.toString());
      if (!response.ok || token !== refreshToken) return;
      const doc = new DOMParser().parseFromString(await response.text(), "text/html");

      picker.querySelectorAll("x-popover").forEach((popover) => {
        const fresh = popover.id && doc.getElementById(popover.id);
        const list = popover.querySelector(".popover__value-list");
        const freshList = fresh && fresh.querySelector(".popover__value-list");
        if (list && freshList) list.innerHTML = freshList.innerHTML;
      });
    } catch (e) {
      // Leave the existing labels in place if the refresh fails
    }
  }

  // Delegated so it also covers radios toggled programmatically by the variant
  // image carousel (which dispatches a bubbling `change` event).
  document.addEventListener("change", (event) => {
    syncLabelFrom(event.target);
    syncDropdownFrom(event.target);
    refreshDropdownLabels(event.target);
  });
})();
